import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { CookieService } from 'ngx-cookie-service'
import { EnvironmentService } from './environment.service'
import { tap } from 'rxjs/operators'
import { UsersApiService } from './users-api.service'
import { RedirectService } from './redirect.service'
import { ActivatedRoute } from '@angular/router'

@Injectable({
  providedIn: 'root'
})
export class SingleSignOnService {
  private _redirectUrl: string
  private _resumePath: string
  private _programIdTestLineNameMap: {[key: string]: any}

  constructor(
    private _route: ActivatedRoute,
    private _usersApiService: UsersApiService,
    private _cookieService: CookieService,
    private _environmentService: EnvironmentService,
    private _redirectService: RedirectService,
    ) {
      this._programIdTestLineNameMap = this._environmentService.get('PROGRAM_ID_TESTLINE_MAP')
      this._route.queryParams.subscribe((params) => {
      this._redirectUrl = params['redirectUrl'] || this._environmentService.get('ATLAS_URL')
      this._resumePath = decodeURIComponent(params['resumePath'])
    })
  }

  public login(user: object): Observable<any> {
    return this._usersApiService.login(user)
      .pipe(
        tap(() => {
          this._redirectService.redirectTo(this._redirectUrl)
        })
      )
  }

  public signup(user: object, meta: object): Observable<any> {
    meta = Object.assign(this._extractRedirectUrlData(), meta)
    return this._usersApiService.signup(user, meta)
      .pipe(
        tap(() => {
          this._redirectService.redirectTo(this._redirectUrl)
        })
      )
  }

  public dropOff(): Observable<any> {
    return this._usersApiService.dropOff(this._getAuthToken(), this._resumePath)
      .pipe(
        tap((response) => {
          this._redirectService.redirectTo(response.body['redirect-url'])
        })
      )
  }
  
  public resetPassword() {
    const testLine = this.getTestLine()
    const baseDomain = this._environmentService.get('BASE_DOMAIN')
    const url = `${baseDomain}/${testLine}/password/reset/`
    this._redirectService.redirectTo(url)
  }

  public isTestlineProvided(){
    return this._extractRedirectUrlData().testline != null
  }

  public getTestLine() {
    return this._extractRedirectUrlData().testline
  }

  private _getAuthToken() {
    return this._cookieService.get('MP-AUTH-TOKEN')
  }

  private _extractRedirectUrlData() {
    const redirectUrlObject = new URL(decodeURIComponent(this._redirectUrl))
    const programId = redirectUrlObject.searchParams.get(this._environmentService.get('REDIRECT_URL_PROGRAM_ID_QUERYPARAM'))
    const testline = this._programIdTestLineNameMap[programId]
    const clientId = redirectUrlObject.searchParams.get(this._environmentService.get('REDIRECT_URL_CLIENT_ID_QUERYPARAM'))

    return {
      testline: testline,
      clientId: clientId
    }
  }
}
